// extracted by mini-css-extract-plugin
module.exports = {"container":"Captcha_container__yycN_","invertedColors":"Captcha_invertedColors__2iNtJ"};